import { get, post, put, del, getPage } from '@/utils/request'
import type { TestCase, TestCaseModule } from '@/types'

/** 用例模块树 */
export const getModuleTree = (projectId: number) =>
  get<TestCaseModule[]>('/test-cases/modules/tree', { project_id: projectId })

/** 创建模块 */
export const createModule = (data: Partial<TestCaseModule>) =>
  post<TestCaseModule>('/test-cases/modules', data)

/** 更新模块名称 */
export const updateModule = (id: number, data: { name: string }) =>
  put<TestCaseModule>(`/test-cases/modules/${id}`, data)

/** 删除模块（需传入 project_id 校验 + 用例检查） */
export const deleteModule = (id: number, projectId: number) =>
  del(`/test-cases/modules/${id}`, { params: { project_id: projectId } })

/** 用例列表 */
export const listCases = (params: {
  project_id: number
  module_id?: number
  page?: number
  page_size?: number
  keyword?: string
  priority?: string
  status?: string
}) => getPage<TestCase>('/test-cases', params)

/** 用例详情 */
export const getCase = (id: number) => get<TestCase>(`/test-cases/${id}`)

/** 创建用例 */
export const createCase = (data: Partial<TestCase>) =>
  post<TestCase>('/test-cases', data)

/** 更新用例 */
export const updateCase = (id: number, data: Partial<TestCase>, projectId: number) =>
  put<TestCase>(`/test-cases/${id}`, data, { params: { project_id: projectId } })

/** 删除用例 */
export const deleteCase = (id: number, projectId: number) => del(`/test-cases/${id}`, { params: { project_id: projectId } })

/** 从 AI 用例导入 */
export const importFromAI = (data: { project_id: number; ai_case_ids: number[] }) =>
  post<{ imported: number; skipped: number }>('/test-cases/import-from-ai', data)
